module.exports = __webpack_public_path__ + "media/unipod/eight_step3-1c4e8370.jpg";